import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import type { ThunkReturnType } from "types";
import { concat } from "util/support";
import { payloadCreator } from "util/api";
import { ApiRouteTypes } from "consts/enpoints/api";
import type { ConstantsResponse, CountriesPaginatedResponse } from "features/general/types";
import { sliceToken as generalSliceToken } from "features/general/state";
import { sliceToken as paymentMethodsSliceToken } from "features/paymentMethods/state";
import type { PaymentMethodsResponse } from "features/paymentMethods/types";
import { getOnboardingsConstants, getOnboardingsCountries, getOnboardingsPaymentMethods } from "./api";

export const getOnboardingsConstantsThunk: AsyncThunk<
    ThunkReturnType<ConstantsResponse>,
    void,
    {}
> = createAsyncThunk(
    concat([generalSliceToken, ApiRouteTypes.GetOnboardingsConstants]),
    payloadCreator(getOnboardingsConstants),
    {
        condition: (_, { getState }) => {
            const { general } = getState() as RootState;
            return ![
                ApiState.Pending,
                ApiState.Succeeded
            ].includes(general.constantsLoadingState);
        }
    }
);

export const getOnboardingsCountriesThunk: AsyncThunk<
    ThunkReturnType<CountriesPaginatedResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([generalSliceToken, ApiRouteTypes.GetOnboardingsCountries]),
    payloadCreator(getOnboardingsCountries),
    {
        condition: (_, { getState }) => {
            const { general } = getState() as RootState;

            return ![
                ApiState.Pending,
                ApiState.Succeeded
            ].includes(general.countriesLoadingState);
        }
    }
);

export const getOnboardingsPaymentMethodsThunk: AsyncThunk<
    ThunkReturnType<PaymentMethodsResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([paymentMethodsSliceToken, ApiRouteTypes.GetOnboardingsPaymentMethods]),
    payloadCreator(getOnboardingsPaymentMethods),
    {
        condition: (_, { getState }) => {
            const { paymentMethods } = getState() as RootState;

            return ![
                ApiState.Pending,
                ApiState.Succeeded
            ].includes(paymentMethods.paymentMethodsLoadingState);
        }
    }
);

